import { motion } from 'motion/react';
import { snappyTween } from './motionUi';

function HotelIcon({ className }) {
  return (
    <svg className={className} width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        d="M4 20V10.5M4 10.5V4h6v6.5M4 10.5h16M10 4v6.5M20 20V10.5M20 10.5V8h-4v2.5M8 14v6M12 14v6M16 14v6"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function PeopleIcon({ className }) {
  return (
    <svg className={className} width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        d="M16 11a3 3 0 1 0-3-3 3 3 0 0 0 3 3ZM8 11a3 3 0 1 0-3-3 3 3 0 0 0 3 3ZM4.5 18.5a4.5 4.5 0 0 1 9 0M10.5 18.5a4.5 4.5 0 0 1 8.5-2.2"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function MessagesIcon({ className }) {
  return (
    <svg className={className} width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 7.5 7.5 0 0 1 10-7 8.38 8.38 0 0 1 3.8.9"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function UserIcon({ className }) {
  return (
    <svg className={className} width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        d="M19 21v-1.5a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4V21M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function PromoIcon({ className }) {
  return (
    <svg className={className} width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        d="M20 12v6a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-6M2 7h20M12 22V7M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7Zm0 0h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SettingsIcon({ className }) {
  return (
    <svg className={className} width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9c.26.604.852.997 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

const headerIconBtnClass =
  'flex h-9 w-9 shrink-0 cursor-pointer items-center justify-center rounded-full text-white/95 outline-none transition-colors hover:bg-white/12 hover:text-white focus-visible:ring-2 focus-visible:ring-white/35 sm:h-10 sm:w-10';

function FusionIcon({ className }) {
  return (
    <span className={className} style={{ fontSize: 18, lineHeight: 1 }} aria-hidden>
      ✦
    </span>
  );
}

function BackpackIcon({ className }) {
  return (
    <svg className={className} width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        d="M5 10v9a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-9M9 21v-4a3 3 0 0 1 6 0v4M5 10a7 7 0 0 1 14 0M9 6V4a3 3 0 0 1 6 0v2"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

const LOBBY_TABS = [
  { id: 'hotel', label: 'Hotel', Icon: HotelIcon },
  { id: 'characters', label: 'Characters', Icon: PeopleIcon },
  { id: 'chat', label: 'Chat', Icon: MessagesIcon },
  { id: 'fusion', label: 'Fusion', Icon: FusionIcon }
];

/**
 * @param {'hotel'|'characters'|'chat'|null|undefined} [props.activeLobbyTab]
 * @param {(tab: 'hotel'|'characters'|'chat') => void} [props.onSelectLobbyTab]
 */
export default function GameTopBar({
  nickname,
  tokens,
  onOpenSettings,
  onOpenPromo,
  onOpenTokenShop,
  onOpenProfile,
  onOpenInventory,
  activeLobbyTab,
  onSelectLobbyTab
}) {
  const nick = nickname?.trim() ? nickname : '';
  const label = nick || 'Your profile';
  const showLobbyTabs = typeof onSelectLobbyTab === 'function';

  const playerBlock = (
    <>
      <span className="flex h-9 w-9 shrink-0 items-center justify-center text-white/95 sm:h-10 sm:w-10">
        <UserIcon className="h-5 w-5" />
      </span>
      <div className="min-w-0 text-left">
        <p className="truncate text-sm font-semibold text-game-text">{label}</p>
      </div>
    </>
  );

  return (
    <motion.header
      layout
      className="relative flex w-full items-center justify-between gap-2 border-b border-[rgba(237,232,229,0.14)] bg-game-chatHeader px-3 py-3 sm:gap-3 sm:px-4"
      initial={{ y: -12, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ type: 'spring', damping: 22, stiffness: 280 }}
    >
      {onOpenProfile ? (
        <motion.button
          type="button"
          transition={snappyTween}
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          onClick={() => onOpenProfile()}
          className="flex min-w-0 max-w-[min(100%,9rem)] shrink-0 items-center gap-2 rounded-xl border border-transparent py-0.5 pl-0.5 pr-1.5 text-left outline-none ring-game-accent/50 transition-colors hover:border-white/10 hover:bg-white/5 focus-visible:ring-2 sm:max-w-[min(100%,14rem)] sm:gap-3 sm:pr-2"
          aria-label="Open profile"
        >
          {playerBlock}
        </motion.button>
      ) : (
        <div className="flex min-w-0 max-w-[9rem] shrink-0 items-center gap-2 sm:max-w-[14rem]">
          {playerBlock}
        </div>
      )}

      {showLobbyTabs ? (
        <nav
          className="absolute left-1/2 top-1/2 z-10 flex w-[min(calc(100vw-7rem),17.5rem)] -translate-x-1/2 -translate-y-1/2 gap-1 sm:w-80 sm:gap-1.5"
          aria-label="Lobby"
        >
          {LOBBY_TABS.map(({ id, label: tabLabel, Icon }) => {
            const active = activeLobbyTab === id;
            return (
              <motion.button
                key={id}
                type="button"
                transition={snappyTween}
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                onClick={() => onSelectLobbyTab(id)}
                className={`flex min-h-[2.75rem] flex-1 basis-0 flex-col items-center justify-center gap-0.5 rounded-xl border px-1 py-1.5 outline-none ring-game-accent/50 transition-colors focus-visible:ring-2 sm:min-h-0 sm:flex-row sm:gap-2 sm:px-2 sm:py-2 ${
                  active
                    ? 'border-game-accent bg-game-accent text-game-accentText shadow-md shadow-black/25 ring-1 ring-white/15'
                    : 'border-white/14 bg-black/20 text-game-body/90 hover:border-white/22 hover:bg-white/10 hover:text-game-text'
                }`}
                aria-current={active ? 'page' : undefined}
              >
                <Icon className={`h-5 w-5 shrink-0 ${active ? 'text-game-accentText' : 'text-current opacity-90'}`} />
                <span className="max-w-full truncate text-[10px] font-semibold leading-tight sm:text-xs">
                  {tabLabel}
                </span>
              </motion.button>
            );
          })}
        </nav>
      ) : null}

      <div className="ml-auto flex shrink-0 flex-wrap items-center justify-end gap-1.5 sm:gap-2">
        {onOpenPromo ? (
          <motion.button
            type="button"
            transition={snappyTween}
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.97 }}
            onClick={onOpenPromo}
            className={headerIconBtnClass}
            aria-label="Promo code"
          >
            <PromoIcon className="h-5 w-5" />
          </motion.button>
        ) : null}
        {onOpenInventory ? (
          <motion.button
            type="button"
            transition={snappyTween}
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.97 }}
            onClick={onOpenInventory}
            className={headerIconBtnClass}
            aria-label="Inventory"
          >
            <BackpackIcon className="h-5 w-5" />
          </motion.button>
        ) : null}
        {onOpenSettings ? (
          <motion.button
            type="button"
            transition={snappyTween}
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.97 }}
            onClick={onOpenSettings}
            className={headerIconBtnClass}
            aria-label="Settings"
          >
            <SettingsIcon className="h-5 w-5" />
          </motion.button>
        ) : null}
        <motion.button
          type="button"
          transition={snappyTween}
          whileHover={{ scale: 1.03 }}
          whileTap={{ scale: 0.97 }}
          onClick={() => onOpenTokenShop?.()}
          className="flex cursor-pointer items-center gap-1.5 rounded-full border border-game-accent/40 bg-game-accent/15 px-2.5 py-1.5 text-left outline-none ring-game-accent/50 transition-colors hover:border-game-accent/60 hover:bg-game-accent/25 focus-visible:ring-2 sm:gap-2 sm:px-3"
          aria-label={`Token balance: ${tokens}. Buy tokens`}
        >
          <span className="text-base leading-none text-game-accent" aria-hidden>
            ◆
          </span>
          <span className="text-sm font-bold tabular-nums text-game-accent">{tokens}</span>
          <span className="hidden text-[10px] font-medium uppercase tracking-wide text-game-accentText/80 sm:inline">
            tokens
          </span>
        </motion.button>
      </div>
    </motion.header>
  );
}
